import { styled as t, Box as l, Typography as c } from "@mui/material";
import f from "../../../assets/images/image-chicken.png.js";
import x from "../next/Image.js";
import h from "../popup/InfoPopup.js";
import { INFO_POPUP_TYPE as d } from "../../../constants/popup.js";
import { jsxs as o, jsx as n } from "react/jsx-runtime";
const u = t(h)`
  max-height: 95%;
  max-width: 95%;

  .Custom-Content {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    overflow-y: auto;
  }
`, k = t(l)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  ${(e) => e.theme.breakpoints.up("res1024")} {
    top: -130px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    top: -30px;
  }
`, P = t(x)`
  aspect-ratio: 1;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    width: 250px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    width: 150px;
  }
`, b = t(c)`
  -webkit-text-stroke: 2px #4f5668;
  color: #f3f8e1;
  font-family: Impact;
  margin-top: -40px;
  position: relative;

  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 50px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 36px;
  }
`, N = (e) => {
  const {
    children: r,
    className: i,
    opened: p,
    title: s,
    onClose: m,
    bottomComponent: a
  } = e;
  return /* @__PURE__ */ o(u, {
    className: i,
    type: d.PURPLE,
    open: p,
    onClose: m,
    children: [r, a, /* @__PURE__ */ o(k, {
      children: [/* @__PURE__ */ n(P, {
        src: f
      }), /* @__PURE__ */ n(b, {
        children: s
      })]
    })]
  });
};
export {
  N as default
};
//# sourceMappingURL=ApeironChickenPopup.js.map
